import { Injectable } from '@angular/core';
import { of, BehaviorSubject, ReplaySubject, Observable, from } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { LoggerService } from '../logger/logger.service';
import { shareReplay } from 'rxjs/internal/operators/shareReplay';
import { Buildings } from './buildings.ResponseModel';
import { BuildingDetails } from './building-details.ResponseModel';
import { map, switchMap, tap, share, catchError } from 'rxjs/operators';
import { BuildingOverview } from './building-overview.Model';
import { ApiResponse } from '../api-response.Model';
import { BuildingModel } from 'src/app/models/building.model';
import { RegistrationModel } from 'src/app/registrations-data/models/data/registration.model';

@Injectable({
  providedIn: 'root',
})
export class BuildingService {
  baseUrl = environment.baseUrlBuildings;

  private buildingid: string;
  private currentId = new BehaviorSubject<string>(this.buildingid);
  buildingIDObserv: Observable<string> = this.currentId
    .asObservable()
    .pipe(shareReplay(1));

  private building: BuildingModel;
  private selectedBuildingModelSubject = new BehaviorSubject<BuildingModel>(
    this.building
  );
  selectedBuildingModel$ = this.selectedBuildingModelSubject.asObservable();

  buildings$: Observable<BuildingOverview[]> = this.httpClient.get<ApiResponse>(this.baseUrl).pipe(
    map(apiResponse => {
      let responseData = new Array<BuildingOverview>();
      if (apiResponse && apiResponse.data) {
        responseData.push(...apiResponse.data);
      }
      return responseData;
    })
  );
  freshBuildingModel$$: any = null;
  buildingTypeCode: string;

  constructor(
    private httpClient: HttpClient,
    private loggerService: LoggerService
  ) { }

  currentlySelectedBuildingDetails(buildingId: string): Observable<RegistrationModel> {
    return this.httpClient.get<RegistrationModel>(this.baseUrl + '/' + buildingId).pipe(shareReplay(1));
  }

  get freshBuildingModel$() {
    if (!this.freshBuildingModel$$) {
      this.freshBuildingModel$$ = this.buildingIDObserv.pipe(
        switchMap((guid) =>
          this.httpClient.get<RegistrationModel>(this.baseUrl + '/' + guid)
        ),
        shareReplay(1)
      );
    }
    return this.freshBuildingModel$$;
  }

  getBuildingBadge(buildingId: string): Observable<any> {
    return this.httpClient.get<any>(this.baseUrl + '/' + buildingId + '/badge').pipe(shareReplay(1));
  }

  setSelectedBuildingModel(bld: BuildingModel) {
    this.building = bld;
    this.selectedBuildingModelSubject.next(bld);
  }

  setBuildingId(id: string) {
    this.currentId.next(id);
    this.buildingid = id;
  }

  getBuildingId() {
    console.log('this' + this.buildingid);
    return this.buildingid;
  }

  getBuilding(): Observable<BuildingDetails> {
    return this.httpClient.get<BuildingDetails>(
      this.baseUrl + '/' + this.buildingid
    );
  }
}
